module.exports = __webpack_public_path__ + "images/emoji/aerial_tramway.fd8e976107fd2fc4fa0d.png";